export default __webpack_public_path__ + "static/media/480_business05-nl-web.e8ef97ed.png";